import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, Grid, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { provideInfoContextKey_Expression, provideInfoContextKey_Protocol, provideInfoContextKey_Score } from '../../../../../modules/provide-info/types.js';
import './Component_ProvideInfoHeader.scss';
import { BadImplementationException, ImplementationMissingException, scrub, voidFunction } from '@nu-art/ts-common';
import { ProtocolStatus_AwaitingInfo } from '../../../../../_utils/ProtocolData/types.js';
import { ModuleFE_ProvideInfo } from '../../../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { ModuleFE_AdvisorMini } from '../../../../../modules/ModuleFE_AdvisorMini.js';
export class Component_ProvideInfoHeader extends ComponentSync {
    //######################### Life Cycle #########################
    __onProvideInfoContextChange = voidFunction;
    __onProvideInfoContextUpdate = (context) => this.forceUpdate();
    deriveStateFromProps(nextProps, state) {
        state.context = nextProps.context;
        return state;
    }
    //######################### Logic #########################
    getScoreValue = (data) => {
        const value = data.calculationResult?.['E'];
        if (typeof value !== 'number')
            return;
        return Math.round(value * 10) / 10;
    };
    //######################### Render #########################
    render() {
        const context = this.state.context;
        if (!context)
            return;
        switch (context.key) {
            case provideInfoContextKey_Protocol:
                return this.render_Protocol(context.data);
            case provideInfoContextKey_Score:
                return this.render_Score(context.data);
            case provideInfoContextKey_Expression:
                throw new BadImplementationException('Expression should not be the base context');
            default:
                // @ts-ignore
                throw new ImplementationMissingException(`Missing implementation for context key ${context.key}`);
        }
    }
    render_Protocol = (data) => {
        const color = data.protocolData.getColor();
        const style = scrub({ '--protocol-color': color });
        return _jsxs(_Fragment, { children: [_jsxs(LL_V_L, { style: style, className: 'provide-info-header__protocol', children: [_jsx("div", { className: 'provide-info-header__title', children: data.protocolData.getLabel() }), _jsx("div", { className: 'provide-info-header__sub-title', children: "How would you like to continue the treatment?" })] }), this.render_Protocol_NavSwitcher(data)] });
    };
    render_Protocol_NavSwitcher = (data) => {
        if (!ModuleFE_AdvisorMini.getIsMiniActive() || data.protocolData.getStatus() !== ProtocolStatus_AwaitingInfo)
            return;
        const buttonLabel = data.navMode ? 'Map' : 'Decision';
        return _jsx(Button, { variant: 'secondary', onClick: () => ModuleFE_ProvideInfo.protocol.toggleNavMode(), children: buttonLabel });
    };
    render_Score = (data) => {
        const value = this.getScoreValue(data);
        return _jsxs(Grid, { className: 'provide-info-header__score', children: [_jsx("div", { className: 'provide-info-header__title', children: data.expression.label }), _jsx("div", { className: 'provide-info-header__sub-title', children: "Score calculation" }), _jsx("div", { className: 'provide-info-header__value', children: value ?? '-' })] });
    };
}
//# sourceMappingURL=Component_ProvideInfoHeader.js.map